import { useEffect } from 'react'

import { useLeadCaptureStore } from '../store/lead-capture-store'
import Text from '../../../components/ui/text'

import { ContactForm } from './contact-form'
import { DiyPath } from './diy-path'
import { HireServicePath } from './hire-service-path'
import { Success } from './success'

interface LeadCaptureContainerProps {
  diyPathOnClick?: () => void | Promise<void>
  onFormSubmit?: (values: unknown) => Promise<void>
  trackChooseYourSuccessPathView?: () => void
  trackChooseYourSuccessPathCTAClicked?: (buttonLocation: string) => void
}

export const LeadCaptureContainer = ({
  diyPathOnClick,
  onFormSubmit,
  trackChooseYourSuccessPathView,
  trackChooseYourSuccessPathCTAClicked,
}: LeadCaptureContainerProps) => {
  const { currentView, setView, setLeadCaptureType, isModalOpen } =
    useLeadCaptureStore()

  useEffect(() => {
    if (trackChooseYourSuccessPathView && isModalOpen) {
      trackChooseYourSuccessPathView()
    }
  }, [trackChooseYourSuccessPathView, isModalOpen])

  const handleDiyPathSelect = async () => {
    if (diyPathOnClick) {
      trackChooseYourSuccessPathCTAClicked?.('do_my_own')
      await diyPathOnClick()
    }
  }

  // TODO: remove unknown and type correctly
  const handleFormSubmit = async (values: unknown) => {
    if (onFormSubmit) {
      await onFormSubmit(values)
    }
  }

  const handleServicePathSelect = (
    option: 'strategic-services' | 'full-service',
  ) => {
    trackChooseYourSuccessPathCTAClicked?.(
      option === 'strategic-services'
        ? 'hire_strategic_services'
        : 'request_full_service_quote',
    )
    setLeadCaptureType(option)
    setView('contact-form')
  }

  const getStep = () => {
    if (currentView === 'initial') {
      return (
        <div className="tw-flex tw-flex-col tw-gap-10">
          <Text
            className="tw-m-0 tw-pt-6 tw-text-center tw-text-2xl tw-font-medium tw-text-zinc-950 lg:tw-text-4xl"
            boldClassName="tw-font-medium"
          >
            onboarding_questionnaire_step7
          </Text>
          <div className="tw-flex tw-flex-col tw-gap-6 tw-p-0 lg:tw-flex-row">
            <DiyPath onClick={handleDiyPathSelect} />
            <HireServicePath
              onClickStrategicServices={() =>
                handleServicePathSelect('strategic-services')
              }
              onClickFullService={() => handleServicePathSelect('full-service')}
            />
          </div>
        </div>
      )
    }

    if (currentView === 'contact-form') {
      return <ContactForm onFormSubmit={handleFormSubmit} />
    }

    if (currentView === 'success') {
      return <Success />
    }
  }

  return (
    <div className="tw-flex tw-flex-col tw-overflow-y-auto">{getStep()}</div>
  )
}
